import {
    getAxiosInstance,
} from '@moeinmdn/mixitweb-front-modules/src/plugin/utils/setInstance.js'
import {queryBuilder} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/QueryFilter.js'

const unwrap = (res) => (res && res.data && res.data.data) || {}

const buildUrl = (path, scope, rootGetters) => {
    if (scope !== 'filter') {
        return path
    }
    const filters = rootGetters['Product/getFilters'] || {}
    const query = queryBuilder(filters)
    return query ? `${path}?${query}` : path
}

const buildBody = (state, payload) => {
    const body = {
        scope: payload.scope,
        operation: payload.operation,
        params: payload.params,
    }
    if (payload.scope === 'selected') {
        body.ids = state.selectedIds.slice()
    }
    return body
}

export default {
    namespaced: true,
    state: {
        selectedIds: [],
    },
    mutations: {
        TOGGLE_ID(state, id) {
            const index = state.selectedIds.indexOf(id)
            if (index === -1) {
                state.selectedIds.push(id)
            } else {
                state.selectedIds.splice(index, 1)
            }
        },
        SELECT_IDS(state, ids) {
            ids.forEach((id) => {
                if (state.selectedIds.indexOf(id) === -1) {
                    state.selectedIds.push(id)
                }
            })
        },
        UNSELECT_IDS(state, ids) {
            state.selectedIds = state.selectedIds.filter((id) => ids.indexOf(id) === -1)
        },
        CLEAR(state) {
            state.selectedIds = []
        },
    },
    actions: {
        toggle({commit}, id) {
            commit('TOGGLE_ID', id)
        },
        selectMany({commit}, ids) {
            commit('SELECT_IDS', ids)
        },
        unselectMany({commit}, ids) {
            commit('UNSELECT_IDS', ids)
        },
        clear({commit}) {
            commit('CLEAR')
        },
        preview({state, rootGetters}, payload) {
            const axios = getAxiosInstance()
            return axios.post(buildUrl('product-bulk-edit/preview', payload.scope, rootGetters), buildBody(state, payload)).then(unwrap)
        },
        apply({state, rootGetters}, payload) {
            const axios = getAxiosInstance()
            return axios.post(buildUrl('product-bulk-edit/apply', payload.scope, rootGetters), buildBody(state, payload)).then(unwrap)
        },
        fetchHistory(context, page = 1) {
            const axios = getAxiosInstance()
            return axios.get('product-bulk-edit', {params: {page}}).then(unwrap)
        },
        fetchItems(context, {id, page = 1, search = ''}) {
            const axios = getAxiosInstance()
            const params = {page}
            if (search) {
                params.search = search
            }
            return axios.get(`product-bulk-edit/${id}/items`, {params}).then(unwrap)
        },
        undoCheck(context, id) {
            const axios = getAxiosInstance()
            return axios.get(`product-bulk-edit/${id}/undo-check`).then(unwrap)
        },
        undo(context, id) {
            const axios = getAxiosInstance()
            return axios.post(`product-bulk-edit/${id}/undo`).then(unwrap)
        },
    },
    getters: {
        selectedIds: (state) => state.selectedIds,
        selectedCount: (state) => state.selectedIds.length,
    },
}
